module.exports = require("./ko-KR.js");